<template>
  <path fill="currentColor" d="M8.7 0A8.7 8.7 0 0 0 0 8.7c0 5.9 7.8 14.7 8.1 15 .3.3.8.3 1.1.1l.1-.1c.3-.4 8.1-9.1 8.1-15 0-4.8-3.9-8.7-8.7-8.7zm0 13.1c-2.4 0-4.4-2-4.4-4.4s2-4.4 4.4-4.4c2.4 0 4.4 2 4.4 4.4 0 2.4-2 4.4-4.4 4.4z"/>
</template>
